var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27272 15.881V11.4605H1.96294V15.881V17.1908H3.27272H7.77506V15.881H3.27272ZM3.27272 1.30977H7.77506V0H3.27272H1.96294V1.30977V5.89398H3.27272V1.30977ZM17.844 1.30977V5.89398H19.1537V1.30977V0H17.844H13.3416V1.30977H17.844ZM17.844 15.881H13.3416V17.1908H17.844H19.1537V15.881V11.4605H17.844V15.881ZM0.23337 7.60739C-0.0415255 7.68991 -0.0847884 8.06102 0.163754 8.20456L6.89316 12.091C6.94336 12.12 6.98496 12.1618 7.01371 12.2121L10.7978 18.8349C10.9399 19.0837 11.3105 19.0428 11.395 18.769L16.1485 3.36221C16.2257 3.11189 15.9924 2.87674 15.7415 2.95205L0.23337 7.60739ZM7.71196 10.6732L3.60879 8.30352L13.86 5.22624L10.721 15.4003L8.43526 11.3999C8.26272 11.0979 8.01313 10.8471 7.71196 10.6732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.17994470bbc83124cd6ef150aa24b3f9.svg";
export { ForwardRef as ReactComponent };